import { CodedProperty, NamedProperty } from "sprint-common-web";

import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { RecordType } from "../../../../common/types/RecordType";
import { ConformingCloudAsset } from "../../../api/GetConformingCloudAssetsResponse";
import { ConformingOnPremAsset } from "../../../api/GetConformingOnPremAssetsResponse";
import { getAssetFilePathOrDefault } from "../../../common/utils/getAssetFilePathOrDefault";

export type ConformingAssetListingItem =
    | ConformingVideoAssetListingItem
    | ConformingAudioAssetListingItem
    | ConformingSubtitleAssetListingItem;

interface ConformingAssetItemBase {
    id: string;
    path: string;
}

interface ConformingVideoAssetListingItem extends ConformingAssetItemBase {
    recordType: RecordType.Video;
    details: {
        aspectRatio: NamedProperty;
        subtitle: CodedProperty;
    };
}

interface ConformingAudioAssetListingItem extends ConformingAssetItemBase {
    recordType: RecordType.Audio;
    details: {
        soundtrack: CodedProperty;
    };
}

interface ConformingSubtitleAssetListingItem extends ConformingAssetItemBase {
    recordType: RecordType.Subtitle;
    details: {
        subtitle: CodedProperty;
        subtitleType: DynamicSubtitleType;
    };
}

export const mapToConformingOnPremAssetListingItem = (
    res: ConformingCloudAsset | ConformingOnPremAsset
): ConformingAssetListingItem => {
    switch (res.recordType) {
        case RecordType.Video:
            return {
                id: res.id,
                path: getAssetFilePathOrDefault(res.path),
                recordType: res.recordType,
                details: {
                    aspectRatio: res.aspectRatio,
                    subtitle: res.subtitle
                }
            };
        case RecordType.Audio: {
            return {
                id: res.id,
                path: getAssetFilePathOrDefault(res.path),
                recordType: res.recordType,
                details: {
                    soundtrack: res.soundtrack
                }
            };
        }
        case RecordType.Subtitle: {
            return {
                id: res.id,
                path: getAssetFilePathOrDefault(res.path),
                recordType: res.recordType,
                details: {
                    subtitle: res.subtitle,
                    subtitleType: res.subtitleType
                }
            };
        }
        default:
            throw new Error("Unknown asset record type");
    }
};
